import { DEFAULT_MARC_ID } from "./constants";

// Mode is in-app React state; the URL is only an entry-point convenience for
// Nolen (?author=001 jumps straight into authoring photo 001; ?label=001
// boots the relabel UI for that photo). No params → 'landing'. The app
// never writes back to the URL.
export const MODES = {
  LANDING: "landing",
  AUTHOR: "author",
  SPEEDRUN: "speedrun",
  LABEL: "label",
  CREATIVE: "creative",
};

export function readUrlState() {
  const params = new URLSearchParams(window.location.search);
  const hasLabel = params.has("label");
  const hasAuthor = params.has("author");
  const labelValue = params.get("label");
  const authorValue = params.get("author");

  let marcId = DEFAULT_MARC_ID;
  let mode = MODES.LANDING;
  if (hasLabel) {
    mode = MODES.LABEL;
    if (labelValue && labelValue.length > 0) marcId = labelValue;
  } else if (hasAuthor) {
    mode = MODES.AUTHOR;
    if (authorValue && authorValue.length > 0) marcId = authorValue;
  }

  // `?debug` reveals iteration UI (currently the scoring-tuner panel).
  // Independent of mode so we can debug-tune scoring inside speedrun
  // without flipping into author.
  const debug = params.has("debug");

  // `?marcs=001,003,007` pins the speedrun lineup for testing instead
  // of the random-from-manifest pick. Order is preserved. Debug-only
  // affordance — no UI links to it. Not validated against the
  // manifest; trust the URL.
  const marcsParam = params.get("marcs");
  const pinnedMarcs = marcsParam
    ? marcsParam
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
    : [];

  return { marcId, mode, debug, pinnedMarcs };
}
